/* 🤖 this file was generated by svg-to-ts */
export const siriusFlagNb: {
  name: 'flag_nb';
  data: string;
} = {
  name: 'flag_nb',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 24" style="display: block;"><g clip-path="url(#a)"><path fill="#ED2939" d="M0 0h32v24H0V0Z"/><path fill="#fff" d="M9 0h8v24H9V0ZM0 8h32v8H0V8Z"/><path fill="#002664" d="M12 0h2v24h-2V0ZM0 11h32v2H0v-2Z"/></g><rect width="31" height="23" x=".5" y=".5" stroke="#000" stroke-opacity=".2" rx="2.5"/><defs><clipPath id="a"><rect width="32" height="24" fill="#fff" rx="3"/></clipPath></defs></svg>`
};
